import {toast} from "react-toastify";

type DownloadOptions = {notify?: boolean; throwOnError?: boolean};

async function download(
  blob: Blob,
  fileName: string,
  {notify = true, throwOnError = false}: DownloadOptions = {}
): Promise<void> {
  let link: HTMLAnchorElement | undefined;
  let objectUrl: string | undefined;
  let downloaded = false;
  try {
    link = document.createElement("a");
    objectUrl = URL.createObjectURL(blob);
    link.href = objectUrl;
    link.download = fileName;
    document.body.append(link);
    link.click();
    downloaded = true;
    if (notify) {
      toast.success(`${fileName} téléchargé`, {autoClose: 1500});
    }
  } catch (error) {
    if (notify) {
      console.error("Error downloading file:", error);
      toast.error("Erreur lors du téléchargement du fichier");
    }
    if (throwOnError) {
      throw error;
    }
  } finally {
    link?.remove();
    if (objectUrl) {
      const url = objectUrl;
      if (downloaded) {
        setTimeout(() => URL.revokeObjectURL(url), 7000);
      } else {
        URL.revokeObjectURL(url);
      }
    }
  }
}
export const downloadService = {
  download,
};
